<template>
  <div ref="fristhome">

    <!-- 卡片 -->
    <el-card class="box-card">
      <!-- 搜索  新增-->
      <el-form
          :inline="true"
          :model="searchForm"
          :rules="searchRules"
          ref="searchForRef"
          autocomplete="on"
          size="mini">
        <el-form-item label="签单开始时间" size="small" label-width="100px">
          <el-date-picker v-model="searchForm.start_time" type="date"  placeholder="请选择开始时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="签单结束时间" size="small" label-width="100px">
          <el-date-picker v-model="searchForm.end_time" type="date"  placeholder="请选择开始时间"></el-date-picker>
        </el-form-item>
        <!-- 面包屑导航 -->
<!--        <el-form-item>-->
<!--          <el-link href="/Welcome">首页</el-link>-->
<!--          <span> > 保险记录</span>-->
<!--        </el-form-item>-->
        <shopCompanyTemp ref="shopCompanyTemp" @changeData="setshopId" ></shopCompanyTemp> <!--运输公司筛选-->
        <!--
        <el-form-item label="订单状态"  label-width="70px">
          <el-select v-model="searchForm.status" filterable clearable placeholder="请选择订单状态">
            <el-option
                v-for="item in orderstatus"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item label="保司"  label-width="70px">
          <el-select v-model="searchForm.corp_id" filterable clearable placeholder="请选择保司">
            <el-option
                v-for="item in corpList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="保单号"  label-width="70px">
          <el-input v-model="searchForm.proposal_form"  placeholder="请输入保单号" clearable type="text"></el-input>
        </el-form-item>
        <el-form-item label="投保单号"  label-width="70px">
          <el-input v-model="searchForm.policy_no"  placeholder="请输入投保单号" clearable type="text"></el-input>
        </el-form-item>
        <el-form-item label="险种"  label-width="70px">
          <el-select class="inputWidth100" v-model="searchForm.product_id" filterable clearable placeholder="请选择险种">
            <el-option
                v-for="(item,index) in pList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车牌"  label-width="70px">
          <el-input v-model="searchForm.plate_number"  placeholder="请输入车牌号" clearable type="text"></el-input>
        </el-form-item>
        <el-form-item label="车架号"  label-width="70px">
          <el-input v-model="searchForm.vin"  placeholder="请输入车架号" clearable></el-input>
        </el-form-item>



        <el-form-item>
          <el-button  type="success" @click="searchSubmit()">搜索</el-button>
        </el-form-item>
        <!--
        <el-form-item>
          <el-tooltip class="item" effect="dark" content="条件：同投保人同保司不同车辆的保险单" placement="top-start">
            <el-button size="mini" type="primary" @click="goPayPublic">对公支付</el-button>
          </el-tooltip>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="warning" @click="goPay">净费支付</el-button>
        </el-form-item>
        -->
        <el-form-item>
          <el-button   @click="toExcel()">导出Excel</el-button>
        </el-form-item>
        <el-form-item>
          <el-button   @click="toPrint()">打印</el-button>
        </el-form-item>

      </el-form>
      <!-- 车辆列表 -->

      <div id="printFrom">
<!--        统计数据-->
        <div>
          <el-tag>
            已选：{{ clickPayNum }}
          </el-tag>
          <el-tag type="success">
            共计保费：{{ clickRealPrice }}
          </el-tag>
          <el-tag type="info">
            共计实际支出：{{ clickPrice }}
          </el-tag>
          <el-tag type="warning">
            共计利润：{{ clickProfit }}
          </el-tag>

          <el-dropdown split-button type="primary" size="small">
            共计车主：{{ clickCarOwners }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="item in CarOwnersData" :key="item">{{item}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-dropdown split-button type="primary" size="small">
            所有人(运输公司)：{{ clickCarPerson }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="item in CarPersonData" :key="item" >{{item}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

        </div>
        <!-- 保险列表 -->
        <el-table
            ref="multipleTable"
            :data="tableLoadData"
            stripe
            border
            height="450"
            size="mini"
            :header-cell-style="{background:'#e5e5e5',color:'#333333'}"
            @selection-change="handleSelectionChange">
          <el-table-column
              type="selection"
              align="center"

              width="50px">
          </el-table-column>

          <el-table-column
              label="车牌号"
              width="90px"
              prop="plate_number"
              :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column
              label="车架号"
              width="70px"
              prop="vin"
              :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column
              label="车主"
              width="60px"
              prop="username"
              :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column
              label="批改"
                width="50px"
              :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <el-link v-if="scope.row.correct_status==3" type="danger">退保</el-link>
              <el-link v-else-if="scope.row.correct_status==1" type="warning">报停</el-link>
              <el-link v-else-if="scope.row.correct_status==2" type="success">复驶</el-link>
            </template>
          </el-table-column>
          <el-table-column
              label="操作"
              width="50px"
              type="expand"
              :show-overflow-tooltip='true'>
            <template slot-scope="scope">
                <el-card>
                  <div  style="width: 70%;text-align:center" >
                      <span v-if="scope.row.product_name=='商业险' || scope.row.product_name === '交强险'">
                        <span v-if="scope.row.correct_status==0">
                          <el-button   type="danger"  size="mini" title="车辆报停" @click="baoTingDialog(scope.row)">报停</el-button>
                        </span>
                        <span v-else-if="scope.row.correct_status==1">
                          <el-button type="success" size="mini" title="复驶" @click="repeatedDrive(scope.row)">复驶</el-button>
                        </span>

                    </span>
                      <span v-if="scope.row.product_md_id > 0">
                      <el-button v-if="!scope.row.tb_info" type="warning" size="mini" title="系统内保险-申请退保" @click="tuiBaoDialog(scope.row)">系统内保险-申请退保</el-button>
                    </span>
                      <span v-else>
                        <span v-if="!scope.row.tb_info">
                          <el-button type="info" size="mini" title="其他渠道-申请退保" @click="tuiBaoDialog(scope.row)">其他渠道-申请退保</el-button>
                        </span>
                        <span>
                          <el-button type="warning" size="mini" @click="handelEdit(scope.row)"><el-icon class="el-icon-edit"></el-icon>订单修改 </el-button>
                        </span>
                        <span>
                          <el-button type="danger" size="mini" @click="handelDel(scope.row)">删除</el-button>
                        </span>

                  </span>
<!--                   报停 复驶 退保 open-->
                    <span v-if="scope.row && scope.row.bt_info && scope.row.bt_info.stop_fileurl">
                      <span>
                        <el-button v-if="scope.row" type="warning" size="mini" icon="el-icon-download"  @click="dowfile222(scope.row.bt_info.stop_fileurl)">下载报停批单</el-button>
                      </span>
                      <span>
                        <el-button v-if="scope.row" type="warning" size="mini" icon="el-icon-document" @click="goDoc222(scope.row.bt_info.stop_fileurl)">查看报停批单</el-button>
                      </span>

                    </span>
                    <span v-if="scope.row && scope.row.bt_info && scope.row.bt_info.go_fileurl">
                          <span>
                            <el-button v-if="scope.row" type="success" size="mini" icon="el-icon-download"  @click="dowfile222(scope.row.bt_info.go_fileurl)">下载复驶批单</el-button>

                          </span>
                          <span>
                            <el-button v-if="scope.row" type="success" size="mini" icon="el-icon-document" @click="goDoc222(scope.row.bt_info.go_fileurl)">查看复驶批单</el-button>

                          </span>


                    </span>
                    <span v-if="scope.row && scope.row.tb_info && scope.row.tb_info.file_url"><!--v-if="scope.row.tb_fileurl"  scope.row.correct_status==3 && scope.row.tb_info && -->
                        <span>
                          <el-button  type="danger" size="mini" icon="el-icon-download"  @click="dowfile222(scope.row.tb_info.file_url)">下载退保批单</el-button>
                        </span>
                        <span>
                          <el-button  type="danger" size="mini" icon="el-icon-document" @click="goDoc222(scope.row.tb_info.file_url)">查看退保批单</el-button>
                        </span>
                    </span>
                    <!--
                    <el-button size="mini" type="primary" v-if="scope.row.correct_status==1" @click="dowfile2(scope.row.correct_status_url)">查看报停</el-button>-->
<!--                   报停 复驶 退保 end -->
                  </div>

                  <div>
                    <br />
                    <h4 v-if="scope.row.tb_info">退保记录</h4>
                    <h4 v-else>暂无退保记录</h4>
                    <el-descriptions v-if="scope.row.tb_info" class="margin-top" direction="vertical" title="" :column="15" border>
                      <el-descriptions-item >
                        <template slot="label">
                          <i class="el-icon-date"></i>
                          退保申请日期 <span class="redStyle">(保单止期，以批单日期为准)</span>
                        </template>
                        {{ scope.row.tb_info.tuibaoDate | dateFormat }}

                      </el-descriptions-item>

                      <el-descriptions-item v-if="scope.row.source==0" label="退保方式" :show-overflow-tooltip='true'>

                        {{ scope.row.tb_info.tuibaoType | TuiBaoTypeFilter }}

                      </el-descriptions-item>
                      <el-descriptions-item label="已使用天数" :show-overflow-tooltip='true'>

                        {{ scope.row.tb_info.usedays }}

                      </el-descriptions-item>
                      <el-descriptions-item label="剩余天数" :show-overflow-tooltip='true'>

                        {{ scope.row.tb_info.useshengyudays }}

                      </el-descriptions-item>
                      <el-descriptions-item label="已使用保费" :show-overflow-tooltip='true'>

                        {{ scope.row.tb_info.usefee }}

                      </el-descriptions-item>
                      <el-descriptions-item label="剩余保费" :show-overflow-tooltip='true'>

                        {{ scope.row.tb_info.shengyu }}

                      </el-descriptions-item>


                      <el-descriptions-item label="退保保费" :show-overflow-tooltip='true'>

                        {{ scope.row.tb_info.tbbf }}

                      </el-descriptions-item>

                      <el-descriptions-item label="退保批单" :show-overflow-tooltip='true'>

                        <el-link v-if="scope.row.tb_info.file_url" type="primary" :href="scope.row.tb_info.file_url" target="_blank">下载</el-link>
                        |
                        <el-link v-if="scope.row.tb_info.file_url" type="success" size="mini"  @click="goDoc222(scope.row.tb_info.file_url)">查看</el-link>
                        <span v-else>暂无</span>
                      </el-descriptions-item>
                      <el-descriptions-item label="退款凭证图片" :show-overflow-tooltip='true'>

                        <viewer v-if="scope.row.tb_info.back_img_url">
                    <span>
                      <img :src="scope.row.tb_info.back_img_url" min-width="20" height="20"/>
                    </span>
                        </viewer>

                        <span v-else>暂无</span>
                      </el-descriptions-item>
                      <el-descriptions-item label="退保理由" :show-overflow-tooltip='true'>

                        {{ scope.row.tb_info.remark }}

                      </el-descriptions-item>

                    </el-descriptions>
                  </div>
                </el-card>

            </template>
          </el-table-column>
          <el-table-column
              label="保险名称"
              width="70"
              prop="product_name"
              :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column
              label="保司"
              width="80"
              prop="corp_name"
              :show-overflow-tooltip='true'>
          </el-table-column>

          <el-table-column
              label="保险金额"
              width="80"
              prop="real_price"
              :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column
              label="保险净费"
              width="80"
              prop="sell_price"
              :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column  label="保险客服"  width="105" prop="corp_tel" :show-overflow-tooltip='true'> <!--other_channels_mobile-->
            <template slot-scope="scope">{{ scope.row | telFilter }}</template>
          </el-table-column>
          <el-table-column  label="投保人"  width="80px"  prop="owner_name"  :show-overflow-tooltip='true'></el-table-column>
          <el-table-column  width="80px"  label="被投保人"   prop="allPerson" :show-overflow-tooltip='true'></el-table-column>
          <el-table-column
              label="签单日期"
              width="100"
              :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <span>{{ scope.row.effective_date | dateFormat }}</span>
            </template>
          </el-table-column>
          <el-table-column label="保险起期"  width="100"  :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <span>{{ scope.row.start_time | dateFormat }}</span>
            </template>
          </el-table-column>
          <el-table-column  label="保险止期"  width="100"  :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <span>{{ scope.row.end_time | dateFormat }}</span>
            </template>
          </el-table-column>
          <el-table-column label="订单状态" width="80" :show-overflow-tooltip='true'>
            <template slot-scope="scope">{{ scope.row.status | statusFilter }}</template>
          </el-table-column>
          <el-table-column label="来源" width="80" prop="source" :show-overflow-tooltip='true'>
            <template slot-scope="scope">{{ scope.row.product_md_id>0 ? '系统内' : '其他渠道' }}</template>
          </el-table-column>
          <el-table-column
              label="备注"
              width="70px"
              prop="remark"
              :show-overflow-tooltip='true'>
          </el-table-column>

          <!--
          <el-table-column v-if="source"  label="出单员"  width="105" prop="other_channels_name"   :show-overflow-tooltip='true'> </el-table-column>
          <el-table-column v-if="!source"  label="出单员"  width="105" prop="issuer_name"   :show-overflow-tooltip='true'> </el-table-column>-->
          <el-table-column label="出单员"  width="80"  prop="issuer_name" :show-overflow-tooltip='true'>
<!--            <template slot-scope="scope">{{ scope.row | nameFilter }}</template>-->
          </el-table-column>
              <!---->
          <el-table-column
              label="凭证流水号"
              width="105"
              prop="pay_sn"
              :show-overflow-tooltip='true'>
          </el-table-column>

          <el-table-column
              label="支付凭证"
              width="80"
              :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <span @click="handelDialog(scope.row.pay_sn_url)" v-if="scope.row.pay_sn_url" style="color: #3a8ee6">查看</span>
              <span v-else>暂无</span>
            </template>
          </el-table-column>

          <el-table-column
                  width="180px"
                  align="center"
              label="保单" :show-overflow-tooltip='true'>
            <template slot-scope="scope">
                <span v-if="scope.row.esign_file && scope.row.esign_template">
                      <el-button v-if="scope.row.esign_file.signFlowStatus==2" type="primary" size="mini"  @click="checkfile(scope.row,2)">查看投保单</el-button>
                  </span>
              <el-button v-if="scope.row.policy_no_pdf_url" type="success" size="mini"  @click="dowfile(scope.row)">下载</el-button>
              <el-button v-if="scope.row.policy_no_pdf_url" type="primary" size="mini"  @click="goDoc(scope.row)">查看</el-button>
              <el-button v-if="!scope.row.policy_no_pdf_url" size="mini">暂无</el-button>
            </template>
          </el-table-column>

          <el-table-column
              width="180px"
              align="center"
              label="发票" :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <el-button v-if="scope.row.invoice_pdf_url1" type="success" size="mini"  @click="dowfile(scope.row.invoice_pdf_url1)">发票-普票下载</el-button>
              <el-button v-if="scope.row.invoice_pdf_url1" type="primary" size="mini"  @click="goDoc(scope.row.invoice_pdf_url1)">发票-普票查看</el-button>
              <el-button v-if="scope.row.invoice_pdf_url2" type="success" size="mini"  @click="dowfile(scope.row.invoice_pdf_url2)">发票-专票下载</el-button>
              <el-button v-if="scope.row.invoice_pdf_url2" type="primary" size="mini"  @click="goDoc(scope.row.invoice_pdf_url2)">发票-专票查看</el-button>
              <el-button v-if="!scope.row.invoice_pdf_url1 && !scope.row.invoice_pdf_url2" size="mini">暂无</el-button>
            </template>
          </el-table-column>

        </el-table>

      </div>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 30, 100]"
            :page-size="limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="996px" top="15%" center>
        <div>
            <el-form :model="form" :rules="rules" ref="form" size="mini" label-width="100px">
                <el-row :gutter="24">
                    <el-col :span="8">
                        <el-form-item label="主车牌号" >
                            <el-input v-model="form.plate_number" prefix-icon="el-icon-search" @click.native.prevent="chooseCar"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="车辆类型">
                            <el-input type="text" v-model="form.vehicle_type" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="车架号" prop="remark">
                            <el-input v-model="form.vin"/>
                        </el-form-item>
                    </el-col>

                </el-row>
                <el-row :gutter="24">
                    <el-col :span="8">
                        <el-form-item label="投保人" prop="toubao_name">
                            <el-input v-model="form.toubao_name"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="投保人证件" prop="toubao_idcard">
                            <el-input v-model="form.toubao_idcard"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="投保人电话" >
                            <el-input autocomplete='off' v-model="form.toubao_mobile"/>
                        </el-form-item>
                    </el-col>

                </el-row>
                <el-row :gutter="24">
                    <el-col :span="8">
                        <el-form-item label="被保险人" >
                            <el-input v-model="form.owner_name"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="被保险人证件" prop="owner_idcard">
                            <el-input v-model="form.owner_idcard"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="被保险人电话" autocomplete='off' prop="owner_mobile">
                            <el-input v-model="form.owner_mobile"/>
                        </el-form-item>
                    </el-col>
                </el-row>
              <el-row :gutter="24">
                <el-col :span="16">
                  <el-row :gutter="24">
                    <el-col :span="12">
                      <el-form-item label="保费" >
                        <el-input v-model="form.real_price"/>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="保险净费">
                        <el-input v-model="form.sell_price"/>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="24">

                    <el-col :span="12">
                      <el-form-item label="险种" >
                        <el-select
                            clearable
                            v-model="form.product_id"
                            size="mini"
                            placeholder="请选择险种">
                          <el-option
                              v-for="item in pList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="保险公司" >
                        <el-select  v-model="form.corp_id" clearable filterable
                                    allow-create
                                    default-first-option size="mini" placeholder="请输入关键词" >
                          <el-option
                              v-for="item in corpList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="上传文件" >
                  <el-upload class="uploader222" :auto-upload="false" :show-file-list="false" drag :on-change="UploadImageOtherPDF" action="#">
                    <i class="el-icon-upload">

                    </i>

                  </el-upload>
                  </el-form-item>
                  <el-link v-if="form.file_url" :href="form.file_url" type="warning" target="_blank">已上传，可点击下载保单</el-link>
                </el-col>
              </el-row>

                <el-row :gutter="24">
                    <el-col :span="8">
                        <el-form-item label="签单日期" >
                            <el-date-picker v-model="form.effective_date" type="datetime"  placeholder="选择日期" class="inputWidth185" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" ></el-date-picker>
                        </el-form-item>

                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="保险起期" prop="owner_idcard">
                            <el-date-picker v-model="form.start_time" type="datetime"  placeholder="选择日期" class="inputWidth185" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" @change="changeTime" ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="保险止期" prop="owner_mobile">
                            <el-date-picker v-model="form.end_time" type="datetime"  placeholder="选择日期" class="inputWidth185" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" ></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="reset_dialogForm('form')">取 消</el-button>
                <el-button type="primary" @click="submitOtherForm('form')">确 定</el-button>
            </div>
        </div>
    </el-dialog>
   <el-dialog :title='title' center :visible.sync="uploadDialog" top="15%" width="30%" append-to-body>
          <viewer style="height: auto; z-index: 9999">
              <span>
                <img :src="uploadImg" width="500" height="500" />
              </span>
          </viewer>
      </el-dialog>

    <ePay :payVisibleProp.sync="isShowPay" v-on:eventPay="choosePay"/>

    <el-dialog
        :title="title"
        :visible.sync="centerDialogVisible"
        width="40%"
        >
      <el-form :model="baoTingForm" :rules="baoTingRules" ref="baoTingForm" label-width="110px">


        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="报停时长" size="small">
              <el-date-picker
                  v-model="baoTingForm.bt_date"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>

            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="上传批单" size="small">
              <el-upload class="uploader" :auto-upload="false" :show-file-list="false" drag :on-change="UploadImageBaoTing" action="#">
                <i class="el-icon-upload">
              <span class="fontStyle1">将批单文件拖到此处，或
                <span class="fontStyle2">点击上传</span>
              </span>
                </i>

              </el-upload>
              <el-link v-if="baoTingForm.stop_fileurl">
                <i class="el-icon-delete-solid" @click.stop="delImg2">删除文件</i>
              </el-link>
               <el-link v-if="baoTingForm.stop_fileurl" :href="baoTingForm.stop_fileurl" type="warning" target="_blank">{{baoTingForm.stop_fileurl}} - 下载查看</el-link>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="备注" prop="remark" size="small">
              <el-input v-model="baoTingForm.remark" type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="dialog-footer">
          <el-button @click="resetForm">取 消</el-button>
          <el-button type="primary" @click="baoTingSubmit('baoTingForm')">确 定</el-button>
        </div>
      </el-form>

    </el-dialog>
    <el-dialog
        title="其他渠道-退保"
        :visible.sync="tuiBaoDialogVisible"
        width="800px"
    >
      <el-form :model="tuiBaoForm" :rules="tuiBaoRules" ref="tuiBaoForm" label-width="110px">

            <el-descriptions class="margin-top" direction="vertical" :column="6" border>

                  <el-descriptions-item >
                    <template slot="label">
                      退保日期 <span class="redStyle">(保单止期，以批单日期为准)</span>
                    </template>
                    <el-date-picker v-model="tuiBaoForm.tb_date" type="date"  placeholder="选择退保日期"></el-date-picker>

                  </el-descriptions-item>

                  <el-descriptions-item label="已使用天数">
                     <el-input v-model="tuiBaoForm.usedays" clearable></el-input>
                  </el-descriptions-item>
                  <el-descriptions-item label="剩余天数">
                      <el-input v-model="tuiBaoForm.useshengyudays" clearable></el-input>
                  </el-descriptions-item>
                  <el-descriptions-item label="已使用保费">
                    <el-input v-model="tuiBaoForm.usefee" clearable></el-input>
                  </el-descriptions-item>
                  <el-descriptions-item label="剩余保费">
                    <el-input v-model="tuiBaoForm.shengyu" clearable></el-input>
                  </el-descriptions-item>
                  <el-descriptions-item label="退保保费">
                    <el-input v-model="tuiBaoForm.tbbf" clearable></el-input>
                  </el-descriptions-item>

                  <el-descriptions-item label="退保备注">
                    <el-input v-model="tuiBaoForm.remark" type="textarea" placeholder="请输入退保备注"></el-input>
                  </el-descriptions-item>
                  <el-descriptions-item label="上传批单">

                      <el-upload class="uploader" :auto-upload="false" :show-file-list="false" drag :on-change="UploadImageOtherTuiBao" action="#">
                        <i class="el-icon-upload">
                      <span class="fontStyle1">将批单文件拖到此处，或
                        <span class="fontStyle2">点击上传</span>
                      </span>
                        </i>

                      </el-upload>

                       <el-link v-if="tuiBaoForm.file_url" :href="tuiBaoForm.file_url" type="warning" target="_blank">{{tuiBaoForm.file_url}} - 下载</el-link>

                  </el-descriptions-item>

                </el-descriptions>


        <div class="dialog-footer">
          <el-button @click="tuiBaoResetForm(1)">取 消</el-button>
          <el-button type="primary" @click="tuiBaoSubmit('tuiBaoForm')">确 定</el-button>
        </div>
      </el-form>

    </el-dialog>
     <el-dialog
        :title="title"
        :visible.sync="repeatedDialog"
        width="50%"
    >
      <el-form :model="repeatedDriveForm" :rules="repeatedDriveRules" ref="repeatedDriveForm" label-width="110px">

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="复驶日期"  size="small">
              <el-date-picker v-model="repeatedDriveForm.start_time" type="date" placeholder="选择复驶日期"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="上传批单" size="small">
              <el-upload class="uploader" :auto-upload="false" :show-file-list="false" drag :on-change="UploadImagePiDan" action="#">
                <i class="el-icon-upload">
              <span class="fontStyle1">将批单文件拖到此处，或
                <span class="fontStyle2">点击上传</span>
              </span>
                </i>

              </el-upload>
              <el-link v-if="repeatedDriveForm.go_fileurl">
                <i class="el-icon-delete-solid" @click.stop="delImg">删除文件</i>
              </el-link>
               <el-link v-if="repeatedDriveForm.go_fileurl" :href="repeatedDriveForm.go_fileurl" type="warning" target="_blank">{{repeatedDriveForm.go_fileurl}} - 下载查看</el-link>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="dialog-footer">
          <el-button @click="repeatedDialog=false">取 消</el-button>
          <el-button type="primary" @click="repeatedDriveSubmit('repeatedDriveForm')">确 定</el-button>
        </div>
      </el-form>

    </el-dialog>

    <!-- 全局遮罩 图片上传 -->
    <el-dialog :visible.sync="dialogVisibleQuan" :modal="true" :close-on-click-modal="false" :close-on-press-escape="false" width="50%">
      <div class="loading-overlay">
        <div class="loading-spinner" style="font-size:30px;font-weight: bold">
          <i class="el-icon-upload"></i>
          文件上传ing
          <i class="el-icon-loading"></i>
        </div>
      </div>
    </el-dialog>
<!--    系统内退保-->
    <el-dialog
        title="系统内保险-退保"
        :visible.sync="carSystemTuiBaoDialog"
        width="800px"
    >
      <el-form :model="tuiBaoForm" :rules="tuiBaoRules" ref="tuiBaoForm" label-width="110px">

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="退保申请日期"  size="small">
              <el-date-picker v-model="tuiBaoForm.tb_date" type="date"  placeholder="选择退保日期"></el-date-picker><span class="redStyle">(保单止期，以批单日期为准)</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="退保理由"  size="small">
              <el-input v-model="tuiBaoForm.remark" type="textarea" placeholder="请输入退保理由">

              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="dialog-footer">
          <el-button @click="tuiBaoResetForm">取 消</el-button>
          <el-button type="primary" @click="tuiBaoSubmit('tuiBaoForm')">确 定</el-button>
        </div>
      </el-form>

    </el-dialog>
<!--      选择车辆-->
      <eCar :carVisibleProp.sync="isShowCar" v-on:eventCar="chooseCarInfo"/>
  </div>
</template>

<script>
import table2excel from 'js-table2excel'
import print from 'print-js'
import eTable from "../common/eTable.vue";
import moment from 'moment';    //日期时间转换
import eInsurance from "../common/eInsurance";
import ePay from "../common/ePay";
import shopCompanyTemp from "../common/shopCompanyTemp.vue";
import carListTemp from "../common/carlistTemp.vue";
import Watermark from "../../utils/waterMark";
import {formatOrderStatus, getTuiBaoType} from '../../utils/utils/index';
import eCar from "../common/eCar.vue";
export default {
  name: "shipCompany",
  components: {
    eCar,
    eTable,
    eInsurance,
    ePay,
    shopCompanyTemp,
    carListTemp
  },
  props: {},
  data() {
    return {
      dialogVisibleQuan:false,
      isShowPay:false,
      shopList:[],
      corpData:[],
      isShowCar:false,
      // 搜索
      searchForm: {
        shop_id:'',
        status:'',
        plate_number:'',
        start_time:'',
        end_time:'',
        proposal_form:'',
        vin:'',
        corp_id:'',
        product_id:'',
      },
      searchRules: {
        name: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
      },
      orderstatus:[],
      // 数据
      tableLoadData: [],
      limit: 10,
      page:1,// 当前页码
      total:0,//总条目数
      id: '',
      rules: {
        plate_number: [{ required: true, message: '请输入车牌', trigger: 'blur' }],

      },
      dialogFormVisible: false,
      title: '',
      form: {
        name: '',
        file_url: '',
        address: '',
        credit_code: '',
        composition: '',
        business_scope: '',
        incorporation_date: '',
        corporation: '',
        registered_capital: '',
        certificate_no: '',
        effective_date: '',
        end_time: '',
        start_time: '',
        lifespan: '',
        issue_date: '',
        type: '',
        duty_paragraph: '',
        mobile: '',
        bank: '',
        bank_account: '',
          corp_id: '',
          product_id: '',
          sell_price: '',
          real_price: '',
          owner_name: '',
          owner_idcard: '',
          toubao_name: '',
          toubao_idcard: '',
          owner_mobile: '',
          toubao_mobile: '',
      },
      uploadImg: '',
      uploadDialog: false,
      //统计数据open
      clickPayNum:0,
      clickRealPrice:0,
      clickPrice:0,
      clickProfit:0,
      clickCarOwners:0,
      clickCarPerson:0,
      CarOwnersData:[],
      CarPersonData:[],
      //统计数据end
      centerDialogVisible:false,
      baotingData:[],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近四个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 120);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      baoTingForm:{
        'bt_date':'',
        'start_time':'',
        'end_time':'',
        'stop_fileurl':'',
        'remark':'',
        'order_id':'',
      },
      baoTingRules: {
        bt_date: [{ required: true, message: '请选择报停日期', trigger: 'blur' }],
      },
      //退保逻辑open
      tuiBaoDialogVisible:false,
      tuiBaoData:[],
      tuiBaoForm:{
        'tb_date':'',
        'file_url':'',
        'remark':'',
        'order_id':'',
        'tbbf':'',
        'usedays':'',
        'useshengyudays':'',
        'usefee':'',
        'shengyu':'',
      },
      tuiBaoRules: {
        tb_date: [{ required: true, message: '请选择退保日期', trigger: 'blur' }],
      },
      //退保逻辑end
      //车辆复驶open
      repeatedDialog:false,
      repeatedDriveForm:{
        'start_time':'',
        'go_fileurl':'',
        'order_id':'',
      },
      repeatedDriveRules: {
        start_time: [{ required: true, message: '请选择复驶日期', trigger: 'blur' }],
        go_fileurl: [
            { required: true, message: '请选择复驶时长', trigger: 'blur' }
        ]
      },
      //车辆复驶end
      //车辆系统内保险退保open
      carSystemTuiBaoDialog:false,
      //车辆系统内保险退保end
      pList:[],
      corpList:[],
    };
  },
  created() {
    this.DataList()
    this.corpDataList()
    this.getProductList()
    let str = sessionStorage.getItem('userName')+' '+moment().format("yyyy-MM-DD HH:mm:ss")
    this.$nextTick(() => { //要加载完才能获取$refs
      Watermark.set(str,this.$refs.fristhome)
    })
  },
  mounted() {

  },
  filters: {
    //必需
    statusFilter(status) {
      return formatOrderStatus(status)
    },
    //来源
    sourceFilter(source){
        if(source > 0)
        {
          return '其他渠道'
        }else{
          return '系统内'
        }
    },
    //显示的出单员prop="source ? other_channels_name : issuer_name"
    nameFilter(row){
      if(row.source > 0)
        {
          return row.other_channels_name
        }else{
          return row.issuer_name
        }
    },
    //显示出客服电话
    telFilter(row){
      // if(row.source > 0)
      //   {
      //     return row.other_channels_mobile
      //   }else{
          return row.corp_tel
        // }
    },
    //时间格式化
    dateFormat(add_time) {
      if (add_time == undefined) {
        return "";
      }
      return moment(add_time*1000).format("yyyy-MM-DD HH:mm:ss");
    },
    TuiBaoTypeFilter(tuibaoType) {
      return getTuiBaoType(tuibaoType)
    },
  },
  methods: {
    dowfile2(url){
        if(url){
          return new Promise((resolve, reject) => {
            let blob = null;
            let xhr = new XMLHttpRequest();
            xhr.open("GET", url);
            xhr.responseType = "blob";
            xhr.onload = () => {
              blob = xhr.response;
              const blobob = new Blob([blob], { type: 'application/pdf;charset=utf-8' });
              const href = window.URL.createObjectURL(blobob);
              window.open(href, 'newWindow');
              resolve(file);
            };
            xhr.onerror = (e) => {
              reject(e)
            };
            xhr.send();
          });
        }else{
          alert("暂无文件")
        }
     },
      checkfile(row,type=1){
          this.$refs.tk.$el.firstChild.style.height = '100%';
          if(type==1){ //生成
              // this.fileByOrder(row.order_id);
          }else{ // 查看
              //console.log(row.esign_file.signFlowId)
              this.fileSignUrl(row.esign_file.signFlowId);
          }
      },
      //生成查看合同链接 getFileSignUrl
      fileSignUrl(tsignFlowId){
          const param = {
              company_id:sessionStorage.getItem('company_id'),
              access_token:sessionStorage.getItem('token'),
              signFlowId:tsignFlowId
          }
          this.$axios.getFileSignUrl(param).then(res=>{
              if(res.code == 200){
                  //console.log(res)
                  this.fileOrder = true;
                  this.fileUrl = res.data.shortUrl;
                  //window.open(res.data.shortUrl)
              }
          }).catch(error=>{
              //console.log(error);
          })
      },
    dowfile(row){
      window.open(row.policy_no_pdf_url)
    },
    goDoc(row){
      ////console.log(row)
      if(row.policy_no_pdf_url){
        return new Promise((resolve, reject) => {
          let blob = null;
          let xhr = new XMLHttpRequest();
          xhr.open("GET", row.policy_no_pdf_url);
          xhr.responseType = "blob";
          xhr.onload = () => {
            blob = xhr.response;
            const blobob = new Blob([blob], { type: 'application/pdf;charset=utf-8' });
            const href = window.URL.createObjectURL(blobob);
            window.open(href, 'newWindow');
            resolve(file);
          };
          xhr.onerror = (e) => {
            reject(e)
          };
          xhr.send();
        });
      }else{
        alert("暂无文件")
      }
    },
    dowfile222(stop_fileurl){
      if(stop_fileurl){
        window.open(stop_fileurl)
      }else{
        this.$message.error('暂无文件')
      }
    },
    goDoc222(row){
      if(row){
        return new Promise((resolve, reject) => {
          let blob = null;
          let xhr = new XMLHttpRequest();
          xhr.open("GET", row);
          xhr.responseType = "blob";
          xhr.onload = () => {
            blob = xhr.response;
            const blobob = new Blob([blob], { type: 'application/pdf;charset=utf-8' });
            const href = window.URL.createObjectURL(blobob);
            window.open(href, 'newWindow');
            resolve(file);
          };
          xhr.onerror = (e) => {
            reject(e)
          };
          xhr.send();
        });
      }else{
        this.$message.error('暂无文件')
      }
    },
    statusFilter2(status) {
      return formatOrderStatus(status)
    },
    openWin(url) {
      var name;                           //网页名称，可为空;
      var iWidth = 500;                         //弹出窗口的宽度;
      var iHeight = 570;                        //弹出窗口的高度;
      //window.screen.height获得屏幕的高，window.screen.width获得屏幕的宽
      var iTop = (window.screen.height - 30 - iHeight) / 2;       //获得窗口的垂直位置;
      var iLeft = (window.screen.width - 10 - iWidth) / 2;        //获得窗口的水平位置;
      window.open(url, name, 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',toolbar=no,menubar=no,scrollbars=auto,resizable=no,location=no,status=no');
    },
    setshopId(value){
      //this.form.plate_number = value
      this.searchForm.shop_id = value
    },
    dateFormat(add_time) {
      if (add_time == undefined) {
        return "";
      }
      return moment(add_time*1000).format("yyyy-MM-DD HH:mm:ss");
    },
    getTime (time) {
      var date = new Date(time)
      var y = date.getFullYear()
      var m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      var d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
      return y + '-' + m + '-' + d
    },
    getTime22 (time) {
      var date = new Date(time)
      var y = date.getFullYear()
      var m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      var d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
      var h = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
      var mi = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
      var s = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
      return y + '-' + m + '-' + d + ' ' + h +':'+ mi +':'+ s
    },
    goPayPublic(){
      this.$router.push('/payPublic')
    },
    choosePay(){

    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // console.log('handleSelectionChange-val',val);

      // 计算选择的订单的金额
      let priceSum = 0.00;  // 保费
      let sellPriceSum = 0.00;  // 净费
      let profitPriceSum = 0.00;  //利润

      val.forEach((item) => {
        sellPriceSum += parseFloat(item.sell_price);
        priceSum += parseFloat(item.real_price);
        profitPriceSum += Math.round((parseFloat(item.real_price)-parseFloat(item.sell_price))*100)/100;

      });

      this.clickPayNum = val.length + '个';
      this.clickRealPrice = Math.round(priceSum*100)/100 + '元';
      this.clickPrice = Math.round(sellPriceSum*100)/100 + '元';
      this.clickProfit = Math.round(profitPriceSum*100)/100 + '元';
      let uniqueAllPerson = new Set(val.filter(obj => obj.username).map(obj => obj.username));
      let uniqueAllPersons = uniqueAllPerson.size;
      this.clickCarOwners = uniqueAllPersons + '个';
      this.CarOwnersData = uniqueAllPerson;

      let uniqueOwnerName= new Set(val.filter(obj => obj.allPerson).map(obj => obj.allPerson));
      let uniqueOwnerNames = uniqueOwnerName.size;
      this.clickCarPerson = uniqueOwnerNames + '个';
      this.CarPersonData = uniqueOwnerName;
      // 获取当前点击的ids的值
      // let ids = []
      // let ids2 = []
      // val.forEach(v => {
      //   ids.push(v.id)
      //   ids2.push(v.order_id)
      // });
      // this.order_info_product_ids = ids
      // this.orderIDs = ids2
      // //console.log(this.order_info_product_ids, 'order_info_product_ids');
      // //console.log(this.OrderIDs, 'OrderIDs');
    },
    goPay(){
      // 判断当前订单处理id是否存在
      if(this.multipleSelection != undefined  ){
        this.isShowPay = true
      }else{
        this.$message.error('请先选择要处理的订单');
      }
    },
    handelCancel(row){
      this.$confirm('请是否确认退保?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        callback: (action) => {
          if (action === 'confirm') {
            this.$message({
              message: '操作成功！',
              type: 'success'
            })
            //this.$refs.tb.clearSelection()
          } else {
            this.$message({
              message: '已取消操作',
              type: 'warning'
            })

          }
        }
      })
    },
    //接收子组件传过来的值
    chooseCarInfo(car_number,...params){
      // this.searchForm.name=car_number;
        this.form.car_id=params[0]; //车辆ID
        this.form.shop_id=params[4];//投保人ID
        this.form.owner_id=params[4];
        this.form.owner_name=params[2];//被投保人姓名
        this.form.owner_idcard=params[5];//被投保人证件号码
        this.form.owner_mobile=params[6];//被投保人手机号
        this.form.toubao_name=params[2];//投保人姓名
        this.form.toubao_idcard=params[5];//投保人证件号码
        this.form.toubao_mobile=params[6];//投保人身份证号
        this.form.vehicle_type=params[1];//投保人身份证号
    },
    DataList(){
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
        status:'3,4,13,14,5,15',
        page: this.page,
        pageSize:this.limit,
      }
      if(this.searchForm.shop_id)  param.shop_id = this.searchForm.shop_id;
      if(this.searchForm.status) param.status = this.searchForm.status;
      if(this.searchForm.plate_number) param.plate_number = this.searchForm.plate_number;
      if(this.searchForm.start_time) param.start_time = this.getTime(this.searchForm.start_time);
      if(this.searchForm.end_time) param.end_time = this.getTime(this.searchForm.end_time);
      if(this.searchForm.proposal_form) param.proposal_form = this.searchForm.proposal_form;
      if(this.searchForm.vin) param.vin = this.searchForm.vin;
      if(this.searchForm.product_id) param.product_id = this.searchForm.product_id;
      if(this.searchForm.corp_id) param.corp_id = this.searchForm.corp_id;

      this.$axios.getInsuranceOrderList(param).then(res=>{
        if(res.code == 200){
          this.tableLoadData = res.data.data
          this.total = res.data.total
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error=>{
        //console.log(error);
      })
    },
    // 设置每页条数
    handleSizeChange(newSize) {
      this.limit = newSize
      this.DataList()
    },
    // 分页跳转
    handleCurrentChange(newPage) {
      this.page = newPage
      this.DataList()
    },
    // 新增
    addData() {
      this.$router.push('/insuranceAdd');
    },
    addByProduct(){
      this.$router.push('/insuranceAddByProduct');
    },
    addSysProduct(){
      this.$router.push('/insuranceSysProduct');
    },
    addSysCar(){
      this.$router.push('/insuranceSysCar');
    },
    handelEdit(row) {
          this.form = {
        name: '',
            file_url: '',
            address: '',
            credit_code: '',
            composition: '',
            business_scope: '',
            incorporation_date: '',
            corporation: '',
            registered_capital: '',
            certificate_no: '',
            effective_date: '',
            end_time: '',
            start_time: '',
            lifespan: '',
            issue_date: '',
            type: '',
            duty_paragraph: '',
            mobile: '',
            bank: '',
            bank_account: '',
            corp_id: '',
            product_id: '',
            sell_price: '',
            real_price: '',
            owner_name: '',
            owner_idcard: '',
            toubao_name: '',
            toubao_idcard: '',
            owner_mobile: '',
            toubao_mobile: '',
      };
        this.id = row.id;
        this.title = row.plate_number+' - '+row.allPerson+' - 其他渠道 - 订单 修改 ';

        this.form.order_id = row.order_id?row.order_id:'';
        this.form.toubao_name = row.allPerson?row.allPerson:'';
        this.form.plate_number = row.plate_number?row.plate_number:'';
        this.form.vin = row.vin?row.vin:'';
        this.form.vehicle_type = row.vehicle_type?row.vehicle_type:'';
        this.form.owner_name = row.owner_name?row.owner_name:'';
        this.form.owner_idcard = row.owner_idcard?row.owner_idcard:'';
        this.form.owner_mobile = row.owner_mobile?row.owner_mobile:'';
        this.form.toubao_name = row.toubao_name?row.toubao_name:'';
        this.form.toubao_idcard = row.toubao_idcard?row.toubao_idcard:'';
        this.form.toubao_mobile = row.toubao_mobile?row.toubao_mobile:'';
        this.form.effective_date = new Date(row.effective_date*1000);
        this.form.start_time = new Date(row.start_time*1000);
        this.form.end_time = new Date(row.end_time*1000);
        this.form.price = row.price?row.price:0;
        this.form.real_price = row.real_price?row.real_price:0;
        this.form.sell_price = row.sell_price?row.sell_price:0;
        this.form.product_id = row.product_id?row.product_id:'';
        this.form.corp_id = row.corp_id?row.corp_id:'';
        this.dialogFormVisible = true;
    },

    reset_dialogForm(formName) {
      this.dialogFormVisible = false
      this.$nextTick(() => {
        this.$refs[formName].resetFields()
      })
    },

    searchSubmit() {
      this.page=1;
      this.DataList();
    },

    handelDel(e) {
      this.$confirm('此操作将取消该订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          order_id: e.order_id,
        }
        //console.log(param);
        this.$axios.delOtherOrder(param).then(res=>{
          if(res.code == 200){
            this.$message.success(res.msg);
            this.DataList()
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error=>{
          //console.log(error);
        })
      }).catch(() => {
        // 点击取消:不删除了
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
        this.DataList()
      });
      this.teamDialog = false
    },
    // 点击弹出当前的图片
    handelDialog(index) {
      this.uploadDialog = true
      // //console.log('handelDialog-index',index)
      this.uploadImg = index
    },


    toPrint(){
      let params={
        printable: 'printFrom',
        header: '申请表',
        ignore: ['no-print']
      };
      printJS({
        printable: params.printable, // 'printFrom', // 标签元素id
        type: params.type || 'html',
        header: params.header, // '表单',
        targetStyles: ['*'],
        style: '@page {margin:0 10mm};', // 可选-打印时去掉眉页眉尾
        ignoreElements: params.ignore || [], // ['no-print']
        properties: params.properties || null
      })
// 打印指定页面
      // printJS('https://www.example.com/page');

// 打印HTML字符串
      // printJS('<h1>Hello, PrintJS!</h1>');
      // printJS({printable: './static/img/login_bg.0899ffa.jpg', type: 'image', header: '销售单'});
    },
    //支持导出图片和类型转换
    toExcel() {
      const column = [
        {
          title: '车牌号码',
          key: 'plate_number',
          type: 'text'
        },
        {
          title: '车架号',
          key: 'vin',
          type: 'text'
        },
        {
          title: '车主',
          key: 'username',
          type: 'text'
        },
        {
          title: '保险名称',
          key: 'product_name',
          type: 'text'
        },
        {
          title: '保司',
          key: 'corp_name',
          type: 'text'
        },
        {
          title: '保险金额',
          key: 'real_price',
          type: 'text'
        },
        {
          title: '保险净费',
          key: 'sell_price',
          type: 'text'
        },
        {
          title: '保险客服',
          key: 'corp_tel',
          type: 'text'
        },
        {
          title: '投保人',
          key: 'owner_name',
          type: 'text'
        },
        {
          title: '被投保人',
          key: 'allPerson',
          type: 'text'
        },
        {
          title: '签单日期',
          key: 'effective_date_format',
          type: 'text'
        },
        {
          title: '保险起期',
          key: 'start_time_format',
          type: 'text'
        },
        {
          title: '保险止期',
          key: 'end_time_format',
          type: 'text'
        },
        {
          title: '出单员',
          key: 'issuer_name',
          type: 'text'
        },
        {
          title: '订单状态',
          key: 'statusMsg',
          type: 'text'
        },
        {
          title: '来源',
          key: 'sourceMsg',
          type: 'text'
        },
      ]
      //this.tableLoadData
      //let tableDatas = JSON.parse(JSON.stringify( res.data.data))
      for(var i in this.tableLoadData){
        this.tableLoadData[i]['effective_date_format'] = this.getTime(this.tableLoadData[i]['effective_date'] * 1000);
        this.tableLoadData[i]['start_time_format'] = this.getTime(this.tableLoadData[i]['start_time'] * 1000);
        this.tableLoadData[i]['end_time_format'] = this.getTime(this.tableLoadData[i]['end_time'] * 1000);
        this.tableLoadData[i]['statusMsg'] = this.statusFilter2(this.tableLoadData[i]['status']);
        this.tableLoadData[i]['sourceMsg'] = this.tableLoadData[i]['source']? '运输公司':'平台';
        this.tableLoadData[i]['username'] = this.tableLoadData[i]['username']? this.tableLoadData[i]['username']:'';
      }
      ////console.log(this.tableLoadData)
      table2excel(column, this.tableLoadData, '订单数据')
    },
    //车辆报停open
    baoTingDialog(item){

      this.centerDialogVisible = true;
      this.title = "车辆报停---信息："+item.allPerson+"-"+item.plate_number+"-"+item.product_name+"-保险起期："+this.dateFormat(item.start_time)+"保险止期："+this.dateFormat(item.end_time); //item.
      this.baoTingForm = {
        'bt_date':'',
        'start_time':'',
        'end_time':'',
        'stop_fileurl':'',
        'remark':'',
        'order_id':item.order_id,
      };

    },
    baoTingSubmit(formName){

      this.$refs[formName].validate((valid) => {
        if (valid) {

          let btDate = this.baoTingForm.bt_date;
          const startTimeMs = btDate[0];
          const endTimeMs = btDate[1];


          const monthDifference = moment.duration(endTimeMs - startTimeMs).asMonths();
          if (monthDifference > 4){
            this.$message.error('时间范围不能大于四个月');
            return false;
          }

          const param = {
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            start_time:this.getTime(btDate[0]),
            end_time:this.getTime(btDate[1]),
            remark:this.baoTingForm.remark,
            stop_fileurl:this.baoTingForm.stop_fileurl,
            order_id:this.baoTingForm.order_id,
          }
          if(this.id) param.id = this.form.id
          this.$axios.baoTingSave(param).then(res =>{
            if(res.code == 200){
              this.DataList();
              this.$message.success(res.msg);
              this.centerDialogVisible = false;
            }else{
              this.$message.error(res.msg);
            }
          })
        }
      })

    },
    resetForm() {
      this.baoTingForm = {
        'bt_date':'',
        'bt_duration':'',
        'fs_date':'',
        'remark':'',
      };
      this.centerDialogVisible = false;
    },
    selectTime(val) {

      let btDate = this.baoTingForm.bt_date;

      let fsD = moment(btDate).add(val, 'months').subtract(1, 'days');

      this.baoTingForm.fs_date = fsD.format("YYYY-MM-DD");

    },
    //车辆报停end
//车辆退保open
    tuiBaoDialog(item){
      if(item.source==0 || item.product_md_id > 0){//系统出单
        this.carSystemTuiBaoDialog = true;
      }else{
        //其他渠道
        this.tuiBaoDialogVisible = true;
      }

      this.tuiBaoForm = {
        'tb_date':'',
        'remark':'',
        'tbbf':'',
        'usedays':'',
        'useshengyudays':'',
        'usefee':'',
        'shengyu':'',
        'order_id':item.order_id,
      };

    },
    tuiBaoSubmit(formName){

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.tuiBaoForm.tb_date = this.getTime(this.tuiBaoForm.tb_date);
          const param = {
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            tuiBaoForm:this.tuiBaoForm
          }
          if(this.id) param.id = this.form.id
          this.$axios.saveTUiBaoApply(param).then(res =>{
            if(res.code == 200){
              this.DataList();
              this.$message.success(res.msg);
              this.tuiBaoDialogVisible = false;
              this.carSystemTuiBaoDialog = false;
            }else{
              this.$message.error(res.msg);
            }
          })
        }
      })

    },
    tuiBaoResetForm(type) {
      if(type == 1){
        this.tuiBaoDialogVisible = false;
      }else{
        this.carSystemTuiBaoDialog = false;
      }
      this.tuiBaoForm = {
        'tb_date':'',
        'remark':'',
        'order_id':'',
        'tbbf':'',
        'usedays':'',
        'useshengyudays':'',
        'usefee':'',
        'shengyu':'',
      };

    },
    //车辆退保end
    //车辆复驶open
    repeatedDrive(item){
      //获取复驶信息
      this.title = "车辆复驶---信息："+item.allPerson+"-"+item.plate_number+"-"+item.product_name+"\n-保险起期："+this.dateFormat(item.start_time)+"保险止期："+this.dateFormat(item.end_time)+"-报停起期："+this.dateFormat(item.bt_info.start_time)+"报停止期："+this.dateFormat(item.bt_info.end_time);
      this.repeatedDriveForm = {
        'start_time':'',
        'go_fileurl':'',
        'order_id':item.order_id,
      };
      this.repeatedDialog = true;
    },
    repeatedDriveSubmit(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {

          const param = {
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            start_time:this.getTime(this.repeatedDriveForm.start_time),
            go_fileurl:this.repeatedDriveForm.go_fileurl,
            order_id:this.repeatedDriveForm.order_id,
          }
          if(this.id) param.id = this.form.id
          this.$axios.restartCar(param).then(res =>{
            if(res.code == 200){
              this.DataList();
              this.$message.success(res.msg);
              this.repeatedDialog = false;
            }else{
              this.$message.error(res.msg);
            }
          })
        }
      })
    },
    //上传图片的方法
      UploadImagePiDan(file) {
        let _this=this;
        _this.dialogVisibleQuan = true;
        this.repeatedDriveForm.go_fileurl = URL.createObjectURL(file.raw);
        //console.log('UploadImagePiDan-file',file)
        let payFd = new FormData()
        payFd.append('file', file.raw)
        payFd.append('img_type', 18) //复驶
        payFd.append('company_id', sessionStorage.getItem('company_id'))
        payFd.append('access_token', sessionStorage.getItem('token'))
        this.$axios.carUploadImage(payFd).then(res => {
          if (res.code == 200) {
            _this.repeatedDriveForm.go_fileurl = res.data.src;
            this.$message.success(res.msg)
            _this.dialogVisibleQuan = false;
          }else{
            this.$message.error(res.msg)
          }
        }).catch(error => console.log('UploadImagePiDan-error',error))

      },
    //上传图片的方法-报停
      UploadImageBaoTing(file) {
        let _this=this;
        _this.dialogVisibleQuan = true;
        this.baoTingForm.stop_fileurl = URL.createObjectURL(file.raw);
        //console.log('UploadImagePiDan-file',file)
        let payFd = new FormData()
        payFd.append('file', file.raw)
        payFd.append('img_type', 17)
        payFd.append('company_id', sessionStorage.getItem('company_id'))
        payFd.append('access_token', sessionStorage.getItem('token'))
        this.$axios.carUploadImage(payFd).then(res => {
          if (res.code == 200) {
            _this.baoTingForm.stop_fileurl = res.data.src;
            this.$message.success(res.msg)
            _this.dialogVisibleQuan = false;
          }else{
            this.$message.error(res.msg)
          }
        }).catch(error => console.log('UploadImagePiDan-error',error))

      },
     delImg(){
          this.repeatedDriveForm.go_fileurl = '';
      },
    delImg2(){
          this.baoTingForm.stop_fileurl = '';
      },
    //车辆复驶end
    //其他渠道上传图片open
    UploadImageOtherPDF(file) {
      let _this=this;
      _this.dialogVisibleQuan = true;

      let payFd = new FormData()
      payFd.append('file', file.raw)
      payFd.append('img_type', 4)
      payFd.append('company_id', sessionStorage.getItem('company_id'))
      payFd.append('access_token', sessionStorage.getItem('token'))
      this.$axios.carUploadImage(payFd).then(res => {
        if (res.code == 200) {

          this.form.file_url = res.data.src;
          this.$message.success(res.msg)
          _this.dialogVisibleQuan = false;
        }else{
          this.$message.error(res.msg)
        }
      }).catch(error => console.log('UploadImagePiDan-error',error))

    },
    UploadImageOtherTuiBao(file) {
        let _this=this;
        _this.dialogVisibleQuan = true;
        // this.tuiBaoForm.file_url = URL.createObjectURL(file.raw);
        //console.log('UploadImagePiDan-file',file)
        let payFd = new FormData()
        payFd.append('file', file.raw)
        payFd.append('img_type', 17)
        payFd.append('company_id', sessionStorage.getItem('company_id'))
        payFd.append('access_token', sessionStorage.getItem('token'))
        this.$axios.carUploadImage(payFd).then(res => {
          if (res.code == 200) {
            // _this.tuiBaoForm.file_url = res.data.src;
            this.tuiBaoForm.file_url = res.data.src;
            this.$message.success(res.msg)
            _this.dialogVisibleQuan = false;
          }else{
            this.$message.error(res.msg)
          }
        }).catch(error => console.log('UploadImagePiDan-error',error))

      },
     delImg3(){
      console.log('delImg3',this.tuiBaoForm.file_url);
          this.tuiBaoForm.file_url = '';
      },
    //其他渠道上传图片end
      //其他渠道编辑open
      submitOtherForm(formName){
          this.$refs[formName].validate((valid) => {
              if (valid) {
                  const param = {
                      //car_id: this.$refs.carListTemp.form.car_id,//this.form.car_id,
                      order_id:this.form.order_id,
                      car_id:this.form.car_id,  //车辆ID
                      shop_id:this.form.shop_id, //投保人ID
                      owner_id:this.form.owner_id,//被投保人ID
                      owner_name:this.form.owner_name,//被投保人姓名
                      owner_idcard:this.form.owner_idcard,//被投保人证件号码
                      owner_mobile:this.form.owner_mobile,//被投保人手机号
                      toubao_name:this.form.toubao_name,//投保人姓名
                      toubao_idcard:this.form.toubao_idcard,//投保人证件号码
                      toubao_mobile:this.form.toubao_mobile,//投保人身份证号
                      vehicle_type:this.form.vehicle_type,//主车辆类型
                      corp_id:this.form.corp_id,//主车辆类型
                      product_id:this.form.product_id,//主车辆类型
                      real_price:this.form.real_price,//主车辆类型
                      sell_price:this.form.sell_price,//主车辆类型
                      vin:this.form.vin,//主车辆类型
                      plate_number:this.form.plate_number,//主车辆类型
                      file_url:this.form.file_url,
                      effective_date:this.getTime22(this.form.effective_date),//签单日期
                      start_time:this.getTime22(this.form.start_time),//保险起期
                      end_time:this.getTime22(this.form.end_time),//保险结束日期
                      company_id:sessionStorage.getItem('company_id'),
                      access_token:sessionStorage.getItem('token')
                  }
                  if(this.id) param.id = this.form.id
                  this.$axios.editOtherOrderInfo(param).then(res =>{
                      if(res.code == 200){
                          this.DataList()
                          this.$message.success(res.msg)
                          this.dialogFormVisible = false
                      }else{
                          this.$message.error(res.msg);
                      }
                  })
              }
          })
      },
      chooseCar(){
          this.isShowCar=true;
      },
      //其他渠道编辑end
      corpDataList(){
          let param={
              company_id:sessionStorage.getItem('company_id'),
              access_token:sessionStorage.getItem('token'),
              page:1,
              limit:1000
          }
          this.$axios.corpList(param).then(res=>{
              if(res.code == 200){
                  this.corpList = res.data.data;
              }
          }).catch(error=>{
              //console.log(error);
          })
      },
      getProductList(){
          const param = {
              company_id:sessionStorage.getItem('company_id'),
              access_token:sessionStorage.getItem('token'),
            pageNum:1,
            pageSize:100
          }
          this.$axios.insuranceProdcutList(param).then(res=>{
              if(res.code == 200){
                  this.pList=res.data.data;
              }
          }).catch(error=>{
              //console.log(error);
          })
      },
    //选择日期
    changeTime(){
        let tmp1=new Date(this.form.start_time);
        var tmp= moment(tmp1.getFullYear()+"-"+(tmp1.getMonth()+1)+'-'+tmp1.getDate()).add(1, 'y').format('yyyy-MM-DD 23:59:59');

        this.form.end_time = moment(tmp).subtract(+1, 'days').format('yyyy-MM-DD 23:59:59');
    },
  },

};
</script>
<style>
.inputWidth100{
  width: 130px;
}
.table_name{
  font-weight: bold;
  /* border: 1px solid #f00; */
}
.table_name:hover{
  color: #409EFF;
  cursor: pointer;
}
.fontStyle1{
    display: block;
    font-size:14px;
    color: #606266;
  }
  .fontStyle2,.fontStyle3{
    font-size:14px;
    color: #3a8ee6;
  }
  .fontStyle3{
    font-size:22px;
    color: #999;
    position: absolute;
    bottom: 1px;
    right: 1px;
  }
  .dialog-footer{
    text-align: right;
  }
  /deep/.el-dialog__body {
    height: 100%;
  }
.redStyle{
  color: red;
}
.uploader222{
    .el-upload-dragger{
      width: 80px;
      height: 80px;
    }
  .el-upload-dragger .el-icon-upload{
    font-size: 40px;
    margin: 30px auto;
    line-height: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/insurance/insuranceTeamOrder.vue